<template>
	<main>
		<div class="bar">
			<div class="left item" :class="[$route.path == item.link ? 'active' : '']" v-for="(item,index) in menu" :key="index" >
				<div class="box" @click="toLink(item)">
					<div class="icon"></div>
					<div class="tit">{{item.title}}</div>
				</div>
				<div class="select"v-if="item.min">
					<select name="branch" @change.stop="toMin($event)">
						<option style="display:none" selected></option>
						<option :value="v.link" v-for="(v,i) in item.min">{{v.title}}</option>
					</select>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
export default {
	name: 'bar',
	data() {
		var _json = {};
		if(this.util.isOffline()){//线下
			_json = {
				menu:[
					{title:"首页", link:"/"},
					{title:"主会场", link:"/plan"},
					{title:"分论坛",link:"/branch"},
					{title:"线下活动", link:"/offline"},
					{title:"赞助商", link:"/contact/sponsor"},
				],
			}
		}else{
			_json = {
				menu:[
					{title:"首页", link:"/"},
					{title:"主会场", link:"/plan"},
					{title:"分论坛",link:"/branch"},
					{title:"线上展区", link:"https://www.dellemc-solution.com/dtfbooth/2023/esg"},
					{title:"赞助商", link:"/contact/sponsor"},
				],
			}
		}
		return _json;
	},
	components:{

	},
	computed:{

	},
	methods: {
		toMin(event){
			this.toLink({
				link:event.target.value
			})
		},
		toLink(item){
			// if(item.link != '/'){
			// 	this.util.showWait(true);return false;
			// }

			// if(!item.link){
			// 	this.util.showWait(true);return false;
			// }
			// console.log(item);
			this.util.toLink(item.link);
		}
	},
	mounted() {

	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.bar{position: fixed;left:0;bottom:0;width: 100%;height:.98rem;border-top-left-radius: .1rem;border-top-right-radius: .1rem;box-shadow: 0 0 0.1rem .02rem rgba(0,0,0,.1);background: #fff;z-index: 120;display: flex;
	.item{flex: 1;position: relative;
		.box{position: absolute;top:0;left:0;width: 100%;height:100%;z-index:121;
			.icon{height:.4rem;margin-top: .15rem;}
			.tit{font-size: .2rem;line-height:1;margin-top: .12rem; color:#808080;text-align: center;}
		}
		.select{position: absolute;top:0;left:0;width: 100%;height:100%;z-index:122;opacity: 0;}
	}
	.item.active{
		.tit{color:#376f84;}
	}
	@for $i from 1 through 5{
		.item:nth-child(#{$i}){
			.icon{background: url("~@/assets/image/2021/menu#{$i}_a.png") no-repeat center center;background-size: contain;}
		}
		.item:nth-child(#{$i}).active{
			.icon{background: url("~@/assets/image/2021/menu#{$i}.png") no-repeat center center;background-size: contain;}
		}
	}
}
</style>

